import { useAuthStore } from '@/stores/useAuthStore.js'
import { createRouter, createWebHistory } from 'vue-router'
import { layouts } from 'chart.js'
import { usePermissionStore } from '@/stores/usePermissionStore.js'
import { nextTick } from 'vue'
// Lazy load layouts
const AdminLayout = () => import('@/layouts/AdminLayout.vue')
const ClientLayout = () => import('@/layouts/ClientLayout.vue')

const VehicleOrderLayout = () => import('@/layouts/VehicleOrderLayout.vue')
const RatesEntryLayout = () => import('@/layouts/ToyotaRatesLayout.vue')
const PermissionLayout = () => import('@/layouts/PermissionLayout.vue')


const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('@/pages/Login.vue'),
  },
  {
    path: '/otp',
    name: 'otp',
    meta: { requiresAuth: true },
    component: () => import('@/pages/OTP.vue'),
  },
  {
    path: '/sign-up',
    name: 'signUp',
    component: () => import('@/pages/SignUp.vue'),
  },
  {
    path: '/register/:key',
    name: 'ClientRegistration',
    component: () => import('@/pages/ClientForm.vue'),
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    meta: { title: 'Forgot Password' },
    component: () => import('@/pages/ForgotPassword.vue'),
  },

  // Client area
  {
    path: '/client',
    component: ClientLayout,
    meta: { requiresAuth: true, role: 'CL' },
    redirect: { name: 'clientDashboard' },
    children: [
      {
        path: 'dashboard',
        name: 'clientDashboard',
        component: () => import('@/pages/client/Dashboard.vue'),
      },

      // Quotation
      {
        path: 'quotation',
        name: 'clientQuotation',
        component: () => import('@/pages/client/quotation/QuotationList.vue'),
        meta: { moduleType: 'main', title: 'All Quotations' }
      },
      {
        path: 'quotation/approved',
        name: 'clientQuotationApproved',
        component: () => import('@/pages/client/quotation/QuotationList.vue'),
        meta: {
          moduleType: 'approved',
          title: 'Approved Quotations',
          filters:{
            status:['AS']
          }
        }
      },
      {
        path: 'quotation/approvals',
        name: 'clientQuotationApprovals',
        component: () => import('@/pages/client/quotation/QuotationList.vue'),
        meta: {
          moduleType: 'approvals',
          title: 'Pending Approvals',
          filters:{
            status:['CAS']
          }
        }
      },
      // {
      //   path: 'quotation/returned',
      //   name: 'clientQuotationReturned',
      //   component: () => import('@/pages/admin/quotation/QuotationList.vue'),
      //   meta: {
      //     moduleType: 'returned',
      //     title: 'Returned & Revisions',
      //     filters:{
      //       is_revised:1,
      //       status:['RET']
      //     }
      //   }
      // },

    //VOF
      {
        path: 'vehicle-order',
        name: 'clientVehicleOrder',
        component: VehicleOrderLayout,
        redirect: { name: 'clientBookings' },
        children: [
          {
            path: 'bookings',
            name: 'clientBookings',
            component: () => import('@/pages/client/vehicle-order/BookingOrderList.vue')
          },
          {
            path: 'trucking',
            name: 'clientTrucking',
            component: () => import('@/pages/client/vehicle-order/TruckingList.vue')
          },
          {
            path: 'special',
            name: 'clientOthers',
            component: () => import('@/pages/client/vehicle-order/OtherList.vue')
          },
        ],
      },

      // Invoices
      {
        path: 'invoices',
        name: 'clientInvoiceSummaries',
        component: () => import('@/pages/client/invoice-summary/ClientInvoices.vue'),
      },

      // Deliveries
      {
        path: 'deliveries',
        name: 'clientDeliveryReceipts',
        component: () => import('@/pages/client/deliveries/DeliveriesPage.vue'),
      },

      //Profile
      {
        path: 'profile/:code',
        name: 'clientProfile',
        props: true,
        component: () => import('@/pages/client/profile/ProfilePage.vue'),
      },
    ],
  },

  // Admin area
  {
    path: '/admin',
    component: AdminLayout,
    redirect: { name: 'adminDashboard' },
    meta: { requiresAuth: true, role: 'AD' },
    children: [
      {
        path: 'dashboard',
        name: 'adminDashboard',
        component: () => import('@/pages/admin/Dashboard.vue'),

      },
      // Quotation
       {
        path: 'quotation',
        name: 'adminQuotation',
        component: () => import('@/pages/admin/quotation/QuotationList.vue'),
        meta: {
          moduleType: 'main',
          title: 'All Quotations',
          permission: ['quotation.list']
        }
      },
      {
        path: 'quotation/approved',
        name: 'adminQuotationApproved',
        component: () => import('@/pages/admin/quotation/QuotationList.vue'),
        meta: {
          moduleType: 'approved',
          title: 'Approved Quotations',
          filters:{
            status:['AS']
          }
        }
      },
      {
        path: 'quotation/approvals',
        name: 'adminQuotationApprovals',
        component: () => import('@/pages/admin/quotation/QuotationList.vue'),
        meta: {
          moduleType: 'approvals',
          title: 'Pending Approvals',
          filters:{
            status:['FAS']
          }
        }
      },
      {
        path: 'quotation/returned',
        name: 'adminQuotationReturned',
        component: () => import('@/pages/admin/quotation/QuotationList.vue'),
        meta: {
          moduleType: 'returned',
          title: 'Returned & Revisions',
          filters:{
            is_revised:1,
            status:['RET']
          }
         }
      },
      {
        path: 'client',
        name: 'client',
        redirect: { name: 'clientListing' },
        children: [
          {
            path: 'list',
            name: 'clientListing',
            component: () => import('@/pages/admin/setup/clients/ClientsList.vue'),
          },
          {
            path: ':code',
            name: 'clientDetails',
            props: true,
            component: () => import('@/pages/admin/setup/clients/ClientDetailsForm.vue'),
          },
        ],
      },
      {
        path: 'island',
        name: 'islandList',
        component: () => import('@/pages/admin/setup/island/IslandList.vue'),
      },
      {
        path: 'ports',
        name: 'portsList',
        component: () => import('@/pages/admin/setup/ports/PortsList.vue'),
      },
      {
        path: 'vehicles',
        name: 'vehiclesList',
        component: () => import('@/pages/admin/setup/vehicles/VehicleList.vue'),
      },
      {
        path: 'vessel_setup',
        name: 'VesselSetup',
        redirect: 'vesselList',
        children: [
          {
            path: 'list',
            name: 'vesselList',
            component: () => import('@/pages/admin/setup/vessels/VesselList.vue'),
          },
          {
            path: 'routes',
            name: 'vesselRoutes',
            component: () => import('@/pages/admin/setup/vessels/VesselRoutes.vue'),
          },
          {
            path: 'operations',
            name: 'vesselOperations',
            redirect: { name: 'generateVesselVoyage' },
            component: () => import('@/pages/admin/setup/vessels/VesselOperations.vue'),
            children: [
              {
                path: 'generate-voyage',
                name: 'generateVesselVoyage',
                component: () => import('@/pages/admin/setup/vessels/GenerateVesselVoyage.vue'),
              },
              {
                path: 'schedules',
                name: 'vesselSchedules',
                component: () => import('@/pages/admin/setup/vessels/VesselSchedules.vue'),
              },
            ],
          },
        ],
      },
      {
        path: 'rates',
        name: 'ratesList',
        redirect: { name: 'general' },
        children: [
          {
            path: 'general',
            name: 'generalRates',
            component: () => import('@/pages/admin/rates/GeneralRatesList.vue'),
          },
          {
            path: 'toyota',
            name: 'toyotaRatesLayout',
            component: () => import('@/layouts/ToyotaRatesLayout.vue'),
            redirect: { name: 'toyotaRatesMain' },
            children: [
              {
                path: 'list',
                name: 'toyotaRatesMain',
                component: () => import('@/pages/admin/rates/toyota/ToyotaMainList.vue'),
              },
              {
                path: 'vehicle-classes',
                name: 'toyotaVehicleClasses',
                component: () => import('@/pages/admin/rates/toyota/ToyotaVehicleClasses.vue'),
              },
              {
                path: 'locations',
                name: 'toyotaLocations',
                component: () => import('@/pages/admin/rates/toyota/ToyotaLocationRates.vue'),
              }
            ]
          },
          {
            path: 'special',
            name: 'specialRates',
            component: () => import('@/pages/admin/rates/special/SpecialRateMainList.vue'),
          },
        ]
      },
      {
        path: 'bunker-adjustment-factor',
        name: 'bafList',
        component: () => import('@/pages/admin/baf/BAFPage.vue'),
      },
      {
        path: 'cargo-types',
        name: 'cargoTypeList',
        component: () => import('@/pages/admin/setup/cargo-types/CargoTypeList.vue'),
      },
      {
        path: 'mode-of-transpo',
        name: 'modList',
        component: () => import('@/pages/admin/setup/mode-of-transpo/ModeOfTransportation.vue'),
      },
      {
        path: 'quotation-terms',
        name: 'quotationTerms',
        component: () => import('@/pages/admin/setup/quotation-terms/QuotationTerms.vue'),
      },

      {
        path: 'terms-conditions',
        name: 'termsConditions',
        component: () => import('@/pages/admin/setup/terms-condition/TermsCondition.vue'),
      },
      {
        path: 'disclaimer',
        name: 'disclaimerList',
        component: () => import('@/pages/admin/setup/disclaimer/DisclaimerList.vue'),
      },
      {
        path: 'services',
        name: 'servicesList',
        component: () => import('@/pages/admin/setup/services/ServicesList.vue'),
      },
      {
        path: 'subjects',
        name: 'subjectList',
        component: () => import('@/pages/admin/setup/subjects/SubjectList.vue'),
      },
      {
        path: 'dr-setup',
        name: 'drSetup',
        component: () => import('@/pages/admin/setup/dr/DRList.vue'),
      },
      {
        path: 'logistic-service-provider',
        name: 'logisticProvider',
        component: () => import('@/pages/admin/setup/lsp/LogisticServiceProviderList.vue'),
      },

      {
        path: 'permissions',
        name: 'permissions',
        component: PermissionLayout,
        redirect: { name: 'rolePermissions' },
        children: [
          {
            path: 'role',
            name: 'rolePermissions',
            component: () => import('@/pages/admin/setup/permissions/RolePermission.vue'),
          },
          {
            path: 'user',
            name: 'userPermission',
            component: () => import('@/pages/admin/setup/permissions/UserPermission.vue'),
          },
        ]
      },

      // VOF (Vehicle Order)
      {
        path: 'vehicle-order',
        name: 'adminVehicleOrder',
        component: VehicleOrderLayout,
        redirect: { name: 'adminBookings' },
        meta: {
          permission: ['vof.list','booking.list', 'booking-item.list', 'trucking.list']
        },
        children: [
          {
            path: 'bookings',
            name: 'adminBookings',
            component: () => import('@/pages/admin/vehicle-order/BookingOrderList.vue'),
            meta: {
              permission: ['booking.list']
            },
          },
          {
            path: 'orders',
            name: 'adminOrders',
            component: () => import('@/pages/admin/vehicle-order/VehicleOrderList.vue'),
            meta: {
              permission: ['vof.list']
            },
          },
          {
            path: 'booking-items',
            name: 'adminBookingItems',
            component: () => import('@/pages/admin/vehicle-order/BookingItemList.vue'),
            meta: {
              permission: ['booking-item.list']
            },
          },
          {
            path: 'trucking',
            name: 'adminTrucking',
            component: () => import('@/pages/admin/vehicle-order/TruckingList.vue'),
            meta: {
              permission: ['trucking.list']
            },
          },
          {
            path: 'special',
            name: 'adminOthers',
            component: () => import('@/pages/admin/vehicle-order/OtherList.vue'),
          },
        ],
      },

      //Load and unload list
      {
        path: 'load-unload-list',
        name: 'loadUnloadList',
        component:()=> import('@/pages/admin/load-unload-list/LoadAndUnloadList.vue'),
        meta: {
          permission: ['load-and-unload.list']
        },
      },

      // SOF
      {
        path: 'shipping-order',
        name: 'adminShippingOrder',
        redirect: { name: 'adminShippingOrderList' },
        meta: {
          permission: ['sof.list']
        },
        children: [
          {
            path: 'list',
            name: 'adminShippingOrderList',
            component: () => import('@/pages/admin/shipping-order/AdminShippingOrderList.vue'),
          },
          {
            path: ':code',
            name: 'adminCreateShippingOrder',
            props: true,
            meta: {
              permission: ['sof.create', 'sof.update']
            },
            component: () =>
              import('@/pages/admin/shipping-order/ShippingOrderFormDetails.vue'),
          },
        ],
      },

      // DR
      {
        path: 'delivery-receipt',
        name: 'adminDeliveryReceipt',
        redirect: { name: 'adminDeliveryReceiptList' },
        meta: {
          permission: ['dr.list']
        },
        children: [
          {
            path: 'list',
            name: 'adminDeliveryReceiptList',
            component: () => import('@/pages/admin/delivery-receipt-revised/DeliveryReceiptListing.vue'),
          },
          {
            path: ':code',
            name: 'adminCreateDeliveryReceipt',
            props: true,
            meta: {
              permission: ['dr.create', 'dr.update']
            },
            component: () =>
              import('@/pages/admin/delivery-receipt/DeliveryReceiptDetailsForm.vue'),
          },
        ],
      },

      // DR
      {
        path: 'invoice-summary',
        name: 'adminInvoiceSummary',
        redirect: { name: 'adminInvoiceSummaryList' },
        meta: {
          permission: ['invoice.list']
        },
        children: [
          {
            path: 'list',
            name: 'adminInvoiceSummaryList',
            component: () => import('@/pages/admin/invoice-summary/InvoiceSummaryList.vue'),
          },
          {
            path: ':code',
            name: 'adminCreateInvoiceSummary',
            props: true,
            component: () => import('@/pages/admin/invoice-summary/InvoiceSummaryDetails.vue'),
          },
        ],
      },
      {
        path: 'approvers',
        name: 'approvers',
        component: () => import('@/pages/admin/setup/approver/ApproverList.vue'),
      },
      {
        path: '/registration-links',
        name: 'registrationLinksPage',
        component: () => import('@/pages/admin/setup/links/RegistrationLinks.vue'),
      },
      {
        path: 'profile/:code',
        name: 'adminProfile',
        props: true,
        component: () => import('@/pages/profile/ProfilePage.vue'),
      },
      {
        path: 'users',
        name: 'usersPage',
        redirect: { name: 'usersListing' },
        children: [
          {
            path: '',
            name: 'usersListing',
            component: () => import('@/pages/admin/setup/users/UsersPage.vue'),
          },
          {
            path: ':code',
            name: 'userDetails',
            props: true,
            component: () => import('@/pages/profile/ProfilePage.vue'),
          },
        ],
      },
    ],
  },

  // 404 Page
  {
    path: '/:pathMatch(.*)*',
    name: 'Page404',
    component: () => import('@/pages/Error.vue'),
  },
  {
    path: '/under-maintenance',
    name: 'UnderMaintenance',
    component: () => import('@/pages/UnderMaintenance.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})


router.beforeEach(async (to, from, next) => {
  const authStore = useAuthStore()
  const permissionStore = usePermissionStore()
  const isLoggedIn = authStore.isLoggedIn
  const user = authStore.getUserLogInfo
  const isProduction = false
  const guestRoutes = ['login', 'signUp', 'forgotPassword', 'ClientRegistration']

   if (isLoggedIn && guestRoutes.includes(to.name?.toString())) {
    const userType = user?.user_type
    return next({ name: userType === 'AD' ? 'adminDashboard' : 'clientDashboard' })
  }

   if (to.meta.requiresAuth && !isLoggedIn) {
    return next({ name: 'login' })
  }

   if (isLoggedIn) {
    const userType = user?.user_type
    const isOTPValidated = user?.otp_validated
    const requiredRole = to.meta.role

    if (isProduction && !isOTPValidated && to.name !== 'otp') {
      return next({ name: 'otp' })
    }

    if (requiredRole && userType && requiredRole !== userType) {
      return next({ name: userType === 'AD' ? 'adminDashboard' : 'clientDashboard' })
    }

     if (userType === 'AD' && !permissionStore.isLoaded) {
      await permissionStore.getPermissions();
    }

     const requiredPermission = to.meta.permission
    if (requiredPermission) {
      const hasAccess = permissionStore.hasAnyPermission(requiredPermission);

      if (!hasAccess) {
        const fallback = getNearestAccessibleRoute(routes, permissionStore, to, user);
        return next(fallback);
      }
    }
  }

  return next()
})

export default router

function getNearestAccessibleRoute(routesConfig, permissionStore, targetRoute, user) {
  const userType = user?.user_type

  const basePath = userType === 'AD' ? '/admin' : '/client';
  const baseConfig = routesConfig.find(r => r.path === basePath);

  if (!baseConfig || !baseConfig.children) return { name: 'Page404' };

   const findFirstValidRoute = (children) => {
    for (const route of children) {
       if (route.meta?.permission && !permissionStore.hasAnyPermission(route.meta.permission)) {
        continue;
      }

       if (route.name && !route.path.includes(':') && route.name !== targetRoute.name) {
        return { name: route.name };
      }

       if (route.children && route.children.length > 0) {
        const validChild = findFirstValidRoute(route.children);
        if (validChild) return validChild;
      }
    }
    return null;
  };

  const fallback = findFirstValidRoute(baseConfig.children);

   const profileRouteName = userType === 'AD' ? 'adminProfile' : 'clientProfile';

  return fallback || {
    name: profileRouteName,
    params: { code: user?.user_name }
  };
}
